import {
    ColoursObj,
    IDrawerStore,
    MobileDialog,
    MobileDrawer,
    MobileSnackBar,
    TMobileDialog,
    TSnackListStore,
    useDialogStore,
    useDrawerStore,
    useSnackListStore,
} from '@eventr/common-storybook'
import { Backdrop, CircularProgress } from '@mui/material'
import { FC, Fragment } from 'react'
import {
    IImageFrameStore,
    ImageFrame,
    useImageFrameStore,
} from './MobileImageFrame'
import { loadingSignal } from './overlaySignals'

export const OverlayWrapper: FC<{ children: any }> = ({ children }) => {
    const snackListStore: TSnackListStore = useSnackListStore()
    const dialogStore: TMobileDialog = useDialogStore()
    const drawerStore: IDrawerStore = useDrawerStore()
    const imageFrameStore: IImageFrameStore = useImageFrameStore()

    /**
     * Backdrop for loading overlay
     */
    const loadingBackdrop = (
        <Backdrop
            sx={{
                color: ColoursObj.shades.shade3,
                backgroundColor: 'transparent',
                backdropFilter: 'blur(3px)',
                zIndex: (theme) => theme.zIndex.modal + 1,
            }}
            open={loadingSignal.value}
        >
            <CircularProgress id="Loading-signal" color="inherit" />
        </Backdrop>
    )

    return (
        <Fragment>
            <MobileSnackBar
                snackList={snackListStore.snackList}
                onClose={(_, reason) => {
                    if (reason === 'timeout') {
                        snackListStore.clearList()
                    }
                }}
            />
            <MobileDialog dialog={dialogStore.dialog} />
            <MobileDrawer
                drawer={drawerStore.drawer}
                openState={drawerStore.openState}
            />
            <ImageFrame
                open={imageFrameStore.open}
                imageSource={imageFrameStore.source ?? undefined}
            />
            {loadingSignal.value && loadingBackdrop}
            {children}
        </Fragment>
    )
}
